import React from "react";
import MapPointer from "./assets/icons/map-pointer.png"

export default function Card(props) {
    return (
        <div>
            <div className="card">
                <div>
                    <img src={`${props.image}`} className="card--photo"/>
                </div>
                <div className="card--text-container">
                    <div className="card--location-container">
                        <img src={MapPointer} className="img--map-pointer"/>
                        <h1 className="card--location">{props.location}</h1>
                    </div>
                    <h1 className="card--title">{props.title}</h1>
                    <h1 className="card--category">{props.category}</h1>
                    <h1 className="card--date">{props.date}</h1>
                    <h1 className="card-description">{props.description}</h1>
                </div>
            </div>
            <hr/>
        </div>
    )
}

